// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3YWGj","right":"Footer_right__2o-0y","buttons":"Footer_buttons__1gQ2e"};